export const connectorHealthBoardLegacy = [
  { connector: 'microsoft_graph', status: 'operational', uptimePct: 99.98, incidents7d: 0 },
  { connector: 'google_calendar', status: 'degraded', uptimePct: 99.2, incidents7d: 1 },
  { connector: 'whatsapp_cloud', status: 'operational', uptimePct: 99.95, incidents7d: 0 },
  { connector: 'teams_bot', status: 'operational', uptimePct: 99.9, incidents7d: 0 },
  { connector: 'zoom_oauth', status: 'maintenance', uptimePct: 100, incidents7d: 0 },
];

/** Legacy export for existing mockApi consumers */
export const connectorHealthBoard = connectorHealthBoardLegacy;

/** 4 large provider cards (UI) */
export const integrationProviderCards = [
  {
    id: 'microsoft',
    name: 'Microsoft',
    key: 'microsoft',
    status: 'healthy',
    uptimePct: 99.97,
    failures24h: 2,
    affectedTenants: 0,
    icon: 'microsoft',
  },
  {
    id: 'google',
    name: 'Google',
    key: 'google',
    status: 'degraded',
    uptimePct: 98.4,
    failures24h: 14,
    affectedTenants: 6,
    icon: 'google',
  },
  {
    id: 'whatsapp',
    name: 'WhatsApp',
    key: 'whatsapp',
    status: 'healthy',
    uptimePct: 99.92,
    failures24h: 1,
    affectedTenants: 0,
    icon: 'whatsapp',
  },
  {
    id: 'openai',
    name: 'OpenAI',
    key: 'openai',
    status: 'down',
    uptimePct: 96.1,
    failures24h: 42,
    affectedTenants: 12,
    icon: 'openai',
  },
];

export const affectedTenantsByProvider = [
  {
    provider: 'google',
    tenantName: 'Subscriber Co 3',
    tenantId: 'tnt-1002',
    issue: 'Webhook validation failures spiking',
  },
  {
    provider: 'google',
    tenantName: 'High Volume Co 1',
    tenantId: 'tnt-2000',
    issue: 'Calendar sync latency > 2s',
  },
  {
    provider: 'openai',
    tenantName: 'Acme Corp 5 LLC',
    tenantId: 'tnt-1004',
    issue: '429 rate limit during peak',
  },
];

export const integrationRecentIncidents = [
  { id: 'inc-1', ts: new Date(Date.now() - 3600000).toISOString(), provider: 'OpenAI', message: 'Regional latency elevated', resolved: false },
  { id: 'inc-2', ts: new Date(Date.now() - 7200000).toISOString(), provider: 'Google', message: 'OAuth token refresh errors', resolved: true },
  { id: 'inc-3', ts: new Date(Date.now() - 86400000).toISOString(), provider: 'Microsoft', message: 'Graph subscription renewal storm', resolved: true },
];

export const expiringTokensSoon = [
  { tenantCode: 'MH-0003', tenantId: 'tnt-1002', provider: 'google', expiresAt: new Date(Date.now() + 3 * 86400000).toISOString() },
  { tenantCode: 'MH-0011', tenantId: 'tnt-1010', provider: 'microsoft', expiresAt: new Date(Date.now() + 5 * 86400000).toISOString() },
  { tenantCode: 'MH-0018', tenantId: 'tnt-1017', provider: 'whatsapp', expiresAt: new Date(Date.now() + 6 * 86400000).toISOString() },
];

export const integrationDetails = {
  microsoft: {
    version: 'v1.0',
    lastRotatedAt: '2025-03-01T00:00:00Z',
    webhookSubscriptions: 1284,
    avgLatencyMs: 118,
  },
  google: {
    version: 'v3',
    lastRotatedAt: '2025-02-20T00:00:00Z',
    webhookSubscriptions: 620,
    avgLatencyMs: 205,
  },
  whatsapp: {
    version: 'v18',
    lastRotatedAt: '2025-03-15T00:00:00Z',
    phoneNumbers: 44,
    avgLatencyMs: 92,
  },
  openai: {
    version: '2024-08',
    lastRotatedAt: '2025-03-18T00:00:00Z',
    deployments: 3,
    avgLatencyMs: 890,
  },
};

/** Per-tenant+provider detail template */
export function buildIntegrationTenantDetail(tenantId, provider) {
  const valid = provider !== 'openai' || tenantId.endsWith('0');
  return {
    tenantId,
    provider,
    summary: {
      tokenStatus: valid ? 'valid' : 'expired',
      tokenExpiresAt: new Date(Date.now() + (valid ? 14 : -2) * 86400000).toISOString(),
      scopesOk: valid ? 5 : 3,
      scopesTotal: 6,
      scopes: [
        { name: 'calendar.read', ok: true },
        { name: 'calendar.write', ok: valid },
        { name: 'offline_access', ok: true },
        { name: 'mail.send', ok: false },
        { name: 'user.read', ok: true },
        { name: 'webhook.subscribe', ok: valid },
      ],
      webhookStatus: valid ? 'active' : 'failing',
      lastSuccessAt: new Date(Date.now() - 120000).toISOString(),
      lastFailureAt: valid ? null : new Date(Date.now() - 600000).toISOString(),
    },
    jobs: Array.from({ length: 6 }, (_, i) => ({
      id: `ij-${tenantId}-${i}`,
      type: ['sync', 'webhook', 'token_refresh'][i % 3],
      createdAt: new Date(Date.now() - i * 900000).toISOString(),
      status: i === 2 ? 'failed' : 'completed',
      durationMs: 200 + i * 50,
    })),
    payloads: Array.from({ length: 10 }, (_, i) => ({
      id: `pl-${tenantId}-${i}`,
      receivedAt: new Date(Date.now() - i * 300000).toISOString(),
      headers: { 'content-type': 'application/json', 'x-request-id': `req-${i}` },
      bodyPreview: JSON.stringify({ event: 'calendar.updated', resourceId: `cal-${i}`, secret: '***MASKED***' }),
      bodyFull: JSON.stringify({ event: 'calendar.updated', resourceId: `cal-${i}`, secret: 'super-secret' }, null, 2),
      signatureValid: i % 4 !== 0,
    })),
    settings: {
      tenantAppId: 'app-xxxx',
      clientIdMasked: 'cli••••••42',
      webhookUrl: `https://hooks.meetinghub.ai/${provider}/${tenantId}`,
      region: 'eu-west-1',
    },
  };
}

export const webhookLogs = Array.from({ length: 40 }, (_, i) => ({
  id: `wh-${8000 + i}`,
  tenantId: `tnt-${1000 + (i % 20)}`,
  tenantCode: `MH-${String((i % 20) + 1).padStart(4, '0')}`,
  provider: ['microsoft', 'google', 'whatsapp'][i % 3],
  endpoint: `/v1/webhooks/${['cal', 'msg', 'wa'][i % 3]}/ingest`,
  connector: ['microsoft_graph', 'google_calendar', 'whatsapp_cloud'][i % 3],
  eventType: ['calendar.updated', 'message.received', 'subscription.validation'][i % 3],
  httpStatus: i % 11 === 0 ? 500 : i % 7 === 0 ? 404 : 200,
  durationMs: 40 + (i * 13) % 400,
  receivedAt: new Date(Date.now() - i * 120000).toISOString(),
  headers: { 'x-signature': 'sha256=abc…', 'user-agent': 'Graph-Notifier/1.0' },
  body: JSON.stringify({ id: i, type: 'notification' }),
  signatureValid: i % 5 !== 0,
}));
